// extracted by mini-css-extract-plugin
export default {"message":"styles__message--L9OmD","user":"styles__user--5TYBq","message-bubble":"styles__message-bubble--LlFo6"};